
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {LibraryLayout} from '../../components/Library'

export const metadata = {
  "title": "Hyperlink, Year One",
  "date": "2021-06-16",
  "author": "The Hyperlink Team",
  "toc": false,
  "living": false,
  "tags": ["announcement"],
  "description": "Highlights from Hyperlink's first year, and a re-articulation of our vision for the future.",
  "topic": ""
};

const layoutProps = {
  metadata
};
const MDXLayout = ({children}) => <LibraryLayout {...metadata}>{children}</LibraryLayout>
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Happy birthday to Hyperlink!`}</p>
    <p>{`The three of us officially joined forces in June 2020, so we're celebrating Hyperlink's first year — what we intend to be the first of many.`}</p>
    <h2 {...{
      "id": "highlights"
    }}>{`Highlights:`}</h2>
    <ul>
      <li parentName="ul">{`In August 2020, we launched our first batch of courses, developed in our initial Meta Course cohorts in June and July.`}</li>
      <li parentName="ul">{`In the remainder of 2020 we launched two more batches of new courses, and also launched Learning Clubs.`}</li>
      <li parentName="ul">{`This year, we've done launches every month since February. We've experimented with Learning Adventures and first steps towards Departments, as well as 4 more Meta Course cohorts and a number of events.`}</li>
      <li parentName="ul">{`Finally, in the past several months, we've developed the initial version of Hyperspace! (reach out if you'd like to beta test)`}</li>
    </ul>
    <h2 {...{
      "id": "by-the-numbers"
    }}>{`By the numbers:`}</h2>
    <ul>
      <li parentName="ul">{`500+ learners enrolled in a Hyperlink cohort`}</li>
      <li parentName="ul">{`77 cohorts ran or scheduled (37 courses and 14 clubs, 11 with multiple cohorts)`}</li>
      <li parentName="ul">{`35 one-off events (in about half a year)`}</li>
      <li parentName="ul">{`50 people facilitated something on Hyperlink`}</li>
      <li parentName="ul">{`$60k+ total revenue (80% to Hyperlink creators)`}</li>
      <li parentName="ul">{`1k+ newsletter subscribers`}</li>
    </ul>
    <h2 {...{
      "id": "whats-next"
    }}>{`What's next?`}</h2>
    <p>{`One year down, `}{`[∞ / ?!]`}{` to go.`}</p>
    <p>{`We wrote some `}<a parentName="p" {...{
        "href": "https://hyperlink.academy/library/hyperlink-vision-for-learning-futures"
      }}>{`thoughts about our long-term vision`}</a>{` last year. There are more of you following now, so we'd like to re-affirm these goals!`}</p>
    <p>{`We're building Hyperlink to be…`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`A home for lifelong learning`}</strong>{`: contextual, personally determined curriculums; flexible structures and learning environments; continuity of learning…`}</li>
      <li parentName="ul"><strong parentName="li">{`A space for meaningful social experiences`}</strong>{`: intimate and transformative group learning, focused on both learner agency and communal engagement, niche interests and peer interactions…`}</li>
      <li parentName="ul"><strong parentName="li">{`An R&D lab for internet pedagogy`}</strong>{`: supporting research and experimentation in online learning, working with ambitious and creative educators, building infrastructure around this…`}</li>
      <li parentName="ul"><strong parentName="li">{`An engine for the creator economy`}</strong>{`: helping teachers channel knowledge and curiosity in sustainable ways, investing in relationships with early stage teachers, working to make many models possible…`}</li>
      <li parentName="ul"><strong parentName="li">{`A rhizomatic learning network`}</strong>{`: space for interconnected learning communities, from projects to clubs to courses and wider networks; blurring the lines between teachers, learners, schools, and institutions…`}</li>
    </ul>
    <p>{`We're grateful to have you with us, and are excited to continue building Hyperlink together. And a special thanks to the learners and course creators who have been a part of Hyperlink so far!`}</p>
    <p>{`If our mission resonates, a great way to help us is to:`}</p>
    <p>{` `}<strong parentName="p">{`a) share Hyperlink with a friend`}</strong>{` (`}<a parentName="p" {...{
        "href": "https://hyperlink.academy/hypotenuse"
      }}>{`point them here`}</a>{` for updates), or`}</p>
    <p><strong parentName="p">{`b) introduce us to someone we should talk to`}</strong>{` about teaching or other experiments`}</p>
    <p>{`We're always eager to hear your ideas / feedback :)`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;